import React from 'react';

type StatusVariant =
  | 'healthy' |'degraded' |'critical' |'recovering' |'isolated' |'detected' |'classified' |'remediating' |'verifying' |'resolved' |'closed' |'p1' |'p2' |'p3' |'p4' |'active' |'inactive' |'success' |'failed' |'running' |'queued' |'rolled-back';

const variantMap: Record<StatusVariant, { bg: string; text: string; dot: string }> = {
  healthy: { bg: 'bg-success/15', text: 'text-success', dot: 'bg-success' },
  degraded: { bg: 'bg-warning/15', text: 'text-warning', dot: 'bg-warning' },
  critical: { bg: 'bg-danger/15', text: 'text-danger', dot: 'bg-danger' },
  recovering: { bg: 'bg-info/15', text: 'text-info', dot: 'bg-info' },
  isolated: { bg: 'bg-muted/20', text: 'text-muted', dot: 'bg-muted' },
  detected: { bg: 'bg-danger/15', text: 'text-danger', dot: 'bg-danger' },
  classified: { bg: 'bg-warning/15', text: 'text-warning', dot: 'bg-warning' },
  remediating: { bg: 'bg-primary/15', text: 'text-primary', dot: 'bg-primary' },
  verifying: { bg: 'bg-info/15', text: 'text-info', dot: 'bg-info' },
  resolved: { bg: 'bg-success/15', text: 'text-success', dot: 'bg-success' },
  closed: { bg: 'bg-muted/15', text: 'text-muted', dot: 'bg-muted' },
  p1: { bg: 'bg-danger/20', text: 'text-danger', dot: 'bg-danger' },
  p2: { bg: 'bg-warning/20', text: 'text-warning', dot: 'bg-warning' },
  p3: { bg: 'bg-info/20', text: 'text-info', dot: 'bg-info' },
  p4: { bg: 'bg-muted/20', text: 'text-muted-foreground', dot: 'bg-muted' },
  active: { bg: 'bg-success/15', text: 'text-success', dot: 'bg-success' },
  inactive: { bg: 'bg-muted/15', text: 'text-muted', dot: 'bg-muted' },
  success: { bg: 'bg-success/15', text: 'text-success', dot: 'bg-success' },
  failed: { bg: 'bg-danger/15', text: 'text-danger', dot: 'bg-danger' },
  running: { bg: 'bg-primary/15', text: 'text-primary', dot: 'bg-primary' },
  queued: { bg: 'bg-warning/15', text: 'text-warning', dot: 'bg-warning' },
  'rolled-back': { bg: 'bg-warning/20', text: 'text-warning', dot: 'bg-warning' },
};

interface StatusBadgeProps {
  status: StatusVariant;
  label?: string;
  showDot?: boolean;
  size?: 'sm' | 'md';
}

export default function StatusBadge({
  status,
  label,
  showDot = true,
  size = 'sm',
}: StatusBadgeProps) {
  const v = variantMap[status] ?? variantMap.isolated;
  const displayLabel = label ?? status.charAt(0).toUpperCase() + status.slice(1);

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold uppercase tracking-wide
        ${v.bg} ${v.text}
        ${size === 'sm' ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs'}`}
    >
      {showDot && <span className={`w-1.5 h-1.5 rounded-full ${v.dot}`} />}
      {displayLabel}
    </span>
  );
}